import { Col, Row, Select } from 'antd';
import { FC } from 'react';
import { PrettyCard } from '../../customers/customer-rents-tab';
import { useRentsDashboard } from './useRentsDashboard';
import { Activity, Buy, Discount, People } from 'react-iconly';
import YearRentsCard from './year-rents-card';
import LattestRentsCard from './lattest-rents-card';
import TopRentedEquipmentsCard from './top-rented-equipments-card';
import TopCustomersCard from './top-customers-card';
import { getUserData } from '../../../../api/auth';
import BookingsView from '../../bookings/bookings-view';

const RentsDashboard: FC = () => {
  const rentDashboard = useRentsDashboard();

  const userData = getUserData();
  console.log({ userData });
  return (
    <>
      <Row gutter={[32, 0]}>
        <Col span={24}>
          <Row align='middle' justify='space-between'>
            <Col md={12} span={24}>
              <h3>
                Bem vindo de volta, {userData ? userData.username : ''} 👋
              </h3>

              {(userData?.isAdmin ||
                userData?.permissions.includes('dashboard:read')) && (
                <p className='hp-p1-body hp-mb-0'>
                  As suas atualizações e estatísticas da FeelCare estão aqui!
                </p>
              )}
            </Col>
            {(userData?.isAdmin ||
              userData?.permissions.includes('dashboard:read')) && (
              <Col className='hp-mt-sm-24' span={6}>
                <Select
                  style={{ width: '100%' }}
                  value={rentDashboard.selectedPeriod}
                  onChange={rentDashboard.onSelectedPeriodChanged}
                  id='month-select'
                  options={rentDashboard.periodOptions}
                />
              </Col>
            )}
          </Row>
        </Col>

        {(userData?.isAdmin ||
          userData?.permissions.includes('dashboard:read')) &&
          rentDashboard.statistics && (
            <Col span={24} className='hp-mt-32'>
              <Row gutter={[32, 32]}>
                <Col span={24}>
                  <Row gutter={[32, 32]}>
                    <Col xl={6} md={12} span={24}>
                      <PrettyCard
                        Icon={People}
                        value={
                          rentDashboard.statistics?.numberOfActiveCustomers
                        }
                        label={'Clientes Ativos'}
                        unit={''}
                      />
                    </Col>

                    <Col xl={6} md={12} span={24}>
                      <PrettyCard
                        Icon={Buy}
                        value={rentDashboard.statistics.numberOfRents}
                        label='Alugueres'
                        unit={''}
                        color='success'
                      />
                    </Col>
                    <Col xl={6} md={12} span={24}>
                      <PrettyCard
                        Icon={Activity}
                        value={rentDashboard.statistics.billing}
                        label='Faturação'
                        unit={'€'}
                        color='danger'
                      />
                    </Col>
                    <Col xl={6} md={12} span={24}>
                      <PrettyCard
                        Icon={Discount}
                        value={rentDashboard.statistics.arpaIndex}
                        label='ARPA'
                        unit={'€'}
                        color='warning'
                      />
                    </Col>
                    <Col xl={16} span={24} className='hp-overflow-hidden'>
                      <Row gutter={[32, 32]}>
                        <Col span={24}>
                          <YearRentsCard />
                        </Col>

                        <Col span={24}>
                          <LattestRentsCard />
                        </Col>
                      </Row>
                    </Col>
                    <Col xl={8} span={24}>
                      <Row gutter={[32, 32]}>
                        <Col span={24}>
                          <TopRentedEquipmentsCard
                            statistics={rentDashboard.statistics.top5Equipments}
                          />
                        </Col>
                        <Col xl={24} span={24}>
                          <TopCustomersCard
                            statistics={rentDashboard.statistics.top5Customers}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          )}

        {userData?.permissions.includes('self-booking:read') &&
          !userData.permissions.includes('booking:read') &&
          !userData.isAdmin && <BookingsView />}
      </Row>
    </>
  );
};

export default RentsDashboard;
